export enum Http_Methods_Types {
    POST = 'POST',
    GET = 'GET',
    PUT = 'PUT',
    DEL = 'DELETE',
    PATCH = 'PATCH'
}
